import React, { useState, useRef, useEffect } from 'react';
import { ROLE_CONFIG, getRoleConfig } from '../data/roles';

export default function RoleSwitcher({ currentRole, onChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const cfg = getRoleConfig(currentRole);

  useEffect(() => {
    if (!open) return;
    function handleClick(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [open]);

  return (
    <div className="role-switcher" ref={ref}>
      <button className="role-switcher-chip" onClick={() => setOpen(o => !o)}>
        <span className="role-switcher-icon" style={{ color: cfg.color }}>
          <cfg.Icon size={16} />
        </span>
        <span>{cfg.label}</span>
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ opacity: 0.5, transform: open ? 'rotate(180deg)' : 'none', transition: 'transform 150ms ease' }}>
          <path d="M3 4.5L6 7.5L9 4.5" />
        </svg>
      </button>
      {open && (
        <div className="role-switcher-dropdown">
          {ROLE_CONFIG.map(role => (
            <button
              key={role.id}
              className={`role-switcher-option${role.id === currentRole ? ' active' : ''}`}
              onClick={() => { onChange(role.id); setOpen(false); }}
            >
              <span style={{ color: role.color, display: 'flex' }}><role.Icon size={16} /></span>
              <span>{role.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
